import { jsx as n } from "react/jsx-runtime";
import { h as H, i as j, c as y, j as L, k as M } from "../../vendor-BBkOA5CU.js";
import { forwardRef as N, useState as P, useEffect as T } from "react";
import { getSpacingClasses as w } from "../../utils/getSpacingClasses/index.js";
import { loadIcon as B } from "./loadIcon/index.js";
import '../../assets/index12.css';const E = "IAzkAq_baseIcon", R = "IAzkAq_blue", V = "IAzkAq_cactus", D = "IAzkAq_color", G = "IAzkAq_gold", J = "IAzkAq_green", K = "IAzkAq_lg", O = "IAzkAq_magenta", Q = "IAzkAq_md", U = "IAzkAq_moon", W = "IAzkAq_purple", X = "IAzkAq_red", Y = "IAzkAq_sienna", Z = "IAzkAq_sm", ee = "IAzkAq_teal", oe = "IAzkAq_xl", se = "IAzkAq_xs", s = {
  baseIcon: E,
  blue: R,
  cactus: V,
  color: D,
  gold: G,
  green: J,
  lg: K,
  magenta: O,
  md: Q,
  moon: U,
  purple: W,
  red: X,
  sienna: Y,
  sm: Z,
  teal: ee,
  xl: oe,
  xs: se
}, de = N(
  ({
    id: m,
    m: i,
    mt: I,
    mr: f,
    mb: u,
    ml: _,
    p: g,
    pt: k,
    pr: b,
    pb: q,
    pl: z,
    icon: e,
    description: a,
    color: c,
    size: p = "md",
    className: x,
    ...o
  }, r) => {
    const { focusProps: $, isFocused: v, isFocusVisible: h } = H(o), { hoverProps: S, isHovered: C } = j({
      ...o
    }), [d, F] = P(""), l = y(
      {
        [s.baseIcon]: !0,
        [s[p]]: !0,
        ...c ? { [s[c]]: !0, [s.color]: !0 } : void 0,
        ...w({ m: i, mt: I, mr: f, mb: u, ml: _, p: g, pt: k, pr: b, pb: q, pl: z })
      },
      x
    );
    T(() => {
      B(e).then((t = "") => {
        F(t);
      }).catch((t) => {
        console.error(`Failed to load icon "${e}":`, t);
      });
    }, [e]);
    const A = L(m);
    return a ? /* @__PURE__ */ n(M, { children: /* @__PURE__ */ n(
      "span",
      {
        ...o,
        ...S,
        ...$,
        id: A,
        "data-focus-visible": h || void 0,
        "data-focused": v || void 0,
        "data-hovered": C || void 0,
        ref: r,
        "data-icon-name": e,
        className: l,
        role: "img",
        "aria-label": a,
        dangerouslySetInnerHTML: { __html: d }
      }
    ) }) : /* @__PURE__ */ n(
      "span",
      {
        ...o,
        id: A,
        ref: r,
        "data-icon-name": e,
        className: l,
        role: "presentation",
        "aria-hidden": "true",
        dangerouslySetInnerHTML: { __html: d }
      }
    );
  }
);
export {
  de as BaseIcon
};
//# sourceMappingURL=index.js.map
